import React, { useState, useEffect, useRef } from "react";
import { Link, useOutletContext } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Grid, Button, Box, InputBase, MenuItem, Typography, Select, ListItemText, ImageListItem, InputLabel, FormControl } from "@mui/material";
import { Search, ViewComfy, SwapVert } from "@mui/icons-material";
import { GetApi, GetApiParam } from "../../Api/Api";
import { PROJECT_STATUS, ASSIGNED_PROJECT_STATUS } from "../../constants";
import Cards from "../../Components/Cards/Cards";
import CardSkeleton from "../../Components/Cards/CardSkeleton";
import "./Projects.css";

const Projects = () => {
  const sidebarOpen = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [assetData, setAssetData] = useState("");
  const [reviewStatusData, setReviewStatusData] = useState("");
  const [categoryData, setCategoryData] = useState();
  const [serverTime, setServerTime] = useState();
  const [serverDate, setServerDate] = useState();
  const [serverClockTime, setServerClock] = useState(null);
  const [categoryTypeVal, setCategoryTypeVal] = useState("All");
  const [currentSlide, setCurrentSlide] = useState(0); // Current slide index
  const [currentSlideSub, setCurrentSlideSub] = useState(0); // Current slide index
  const [currentSlideReview, setCurrentSlideReview] = useState(0); //Current slide index
  const [currentSlideVoted, setCurrentSlideVoted] = useState(0); //Current slide index
  const [currentSlideRejected, setCurrentSlideRejected] = useState(0); //Current slide index
  const [bookmark, setBookmark] = useState(); // for Bookmark
  const [isReview, setIsReview] = useState(false);
  const [isVoted, setIsVoted] = useState(false);

  // Reference to the carousel component
  const carouselRef = useRef(null);
  const carouselRefSub = useRef(null);
  const carouselRefReview = useRef(null);
  const carouselRefVoted = useRef(null);
  const carouselRefRejected = useRef(null);

  const serverTimeInterval = useRef(null)

  // fetching data from local storage
  const localData = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : "";

  // Initial api call's on page render
  useEffect(() => {
    async function getDraftData() {
      setLoading(true);
      try {
        const payloadData = {
          user_id: localData?.id,
        };
        const res = await GetApiParam("/proposer/getAssetsList/", payloadData);
        if (res?.data) {
          setLoading(false);
          setAssetData(res.data?.data);
          setServerTime(res.data?.server_time);
          setServerDate(res.data?.server_date);
          setTimer(res.data);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    async function getCategoryData() {
      try {
        const res = await GetApi("/proposer/getCategory/");
        setCategoryData(res?.data?.data);
      } catch (error) {
        console.log(error);
      }
    }
    async function getReviewConfirmationData() {
      try {
        const payloadData = {
          user_id: localData?.id,
        };
        const res = await GetApiParam("/user/getAssignProject", payloadData);
        setReviewStatusData(res?.data?.data);
      } catch (error) {
        console.log(error);
      }
    }
    async function getBookmarkData() {
      try {
        const payloadData = {
          user_id: localData?.id,
        };
        const res = await GetApiParam("/proposer/getBookmark/", payloadData);
        setBookmark(res?.data?.data ? res?.data?.data : []);
      } catch (error) {
        console.log(error);
      }
    }
    if (localData?.id) {
      // Api to get InvestmentTypeData
      const timer = setTimeout(() => {
        getBookmarkData()
        getReviewConfirmationData();
        getDraftData();
        getCategoryData();
      }, 20);
      return () => clearTimeout(timer);
    }

  }, [sidebarOpen]);

  const handleChangeCategory = (event) => {
    setCategoryTypeVal(event.target.value);
    // Reset the current slide to 0
    setCurrentSlide(0);
    setCurrentSlideSub(0);
    setCurrentSlideReview(0);
    setCurrentSlideVoted(0);
    setCurrentSlideRejected(0);
    // Scroll to the first slide
    if (
      carouselRef.current &&
      carouselRefSub.current &&
      carouselRefReview.current &&
      carouselRefVoted.current &&
      carouselRefRejected

    ) {
      carouselRef.current.goToSlide(0);
      carouselRefSub.current.goToSlide(0);
      carouselRefReview.current.goToSlide(0);
      carouselRefVoted.current.goToSlide(0);
      carouselRefRejected.current.goToSlide(0)
    }
  };

  // Filter functionality for the dropdown
  useEffect(() => {
    async function getFilterData() {
      try {
        if (categoryTypeVal.length > 0 || categoryTypeVal === "All") {
          var categoryId = "";
          categoryData?.map((val, ind) => {
            if (val.title === categoryTypeVal) {
              categoryId = val.id;
            }
          });

          const localData = JSON.parse(localStorage.getItem("user_data"));

          let filterDataPayload = {
            user_id: localData?.id,
          };
          if (categoryId && categoryId != "All") {
            filterDataPayload.category_id = categoryId;
          } else {
            delete filterDataPayload.category_id;
          }

          const res = await GetApiParam(
            "/proposer/getAssetsList/",
            filterDataPayload
          );

          if (res?.data?.data) {
            setAssetData(res?.data?.data);
          }

          const resSearchProject = await GetApiParam("/user/getAssignProject", filterDataPayload);

          if (resSearchProject?.data?.data) {
            setReviewStatusData(resSearchProject?.data?.data);
          }

          // when user will select All for both the filter
          // if (categoryTypeVal === "All") {
          //   const res = await GetApiParam(
          //     "/proposer/getAssetsList/",
          //     filterDataPayload
          //   );
          //   if (res?.data?.data) {
          //     setAssetData(res?.data?.data);
          //   }
          // }
        }
      } catch (error) {
        console.log(error);
      }
    }
    getFilterData();
  }, [categoryTypeVal, categoryData]);

  // functionality for Timer
  function setTimer(res) {
    // initialize server clock
    if (res?.data?.length > 0) {
      const serverClockTime = new Date(res?.server_date);
      var timestamp = res?.server_time.split(":");
      serverClockTime.setHours(timestamp[0]);
      serverClockTime.setMinutes(timestamp[1]);
      serverClockTime.setSeconds(timestamp[2]);
      setServerClock(serverClockTime);
    }
  }

  useEffect(() => {
    serverTimeInterval.current = setInterval(() => {
      if (serverClockTime) {
        serverClockTime.setSeconds(serverClockTime.getSeconds() + 1);
        setServerClock(serverClockTime);
        const event = new CustomEvent("clocktime", {
          detail: serverClockTime,
          bubbles: true,
        });
        document.dispatchEvent(event);
      }
    }, 1000);

  }, [serverClockTime])

  /**
   * add book marks
   * @param {*} asset_id
   * @returns
   */
  const bookmarkVal = (asset_id) => {
    return bookmark?.some(
      (item) => item.asset_id === asset_id && item.status === 1
    );
  };

  const projectSearch = async (toSearch) => {
    const payloadData = {
      asset_title: toSearch,
      user_id: localData?.id,
    };

    var categoryId = "";
    categoryData?.map((val, ind) => {
      if (val.title === categoryTypeVal) {
        categoryId = val.id;
      }
    });

    if (categoryId && categoryId != "All") {
      payloadData.category_id = categoryId;
    } else {
      delete payloadData.category_id;
    }

    if (toSearch.length > 2) {
      try {
        const res = await GetApiParam("/proposer/getAssetsList/", payloadData);
        const resSearchProject = await GetApiParam("/user/getAssignProject", payloadData);
        setReviewStatusData(resSearchProject?.data?.data);
        setAssetData(res?.data?.data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const payloadData = {
          user_id: localData?.id,
        };
        const res = await GetApiParam("/proposer/getAssetsList/", payloadData);
        const resSearchProject = await GetApiParam("/user/getAssignProject", payloadData);
        setAssetData(res?.data?.data);
        setReviewStatusData(resSearchProject?.data?.data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Product slider
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 6,
    },
    desktopXXl: {
      breakpoint: { max: 3000, min: 2000 },
      items: 5,
    },
    desktopXl: {
      breakpoint: { max: 2000, min: 1400 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1400, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1023, min: 601 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  };

  // payload for Draft see all
  const payloadDraft = {
    user_id: localData ? localData.id : "",
    status: PROJECT_STATUS.DRAFT,
  };

  // payload for Submmited see all
  const payloadSubmitted = {
    user_id: localData ? localData.id : "",
    status: PROJECT_STATUS.SUBMITTED,
  };

  /**
  * Getting status values from Asset Data to apply condition for displaying
  */
  useEffect(() => {
    if (reviewStatusData?.length) {
      let review = false;
      let voted = false;
      for (let i = 0; i < reviewStatusData?.length; i++) {
        const votedStatus = reviewStatusData[i]?.dicMemberData?.some((items) => items.status === ASSIGNED_PROJECT_STATUS.APPROVED || items.status === ASSIGNED_PROJECT_STATUS.REJECTED);
        const reviewStatus = reviewStatusData[i]?.dicMemberData?.some((items) => items.status === ASSIGNED_PROJECT_STATUS.INPROGRESS || items.status === ASSIGNED_PROJECT_STATUS.REVIEWED || items.status === ASSIGNED_PROJECT_STATUS.NOT_REVIEWED);

        if (votedStatus) {
          voted = true
        }
        if (reviewStatus) {
          review = true
        }
      }
      if (voted) {
        setIsVoted(true)
      }
      if (review) {
        setIsReview(true)
      }
    }
  }, [reviewStatusData])

  return (
    <>
      {/* hide for private race-ecosystem */}
      <Box className='coming-soon-my-project'>
        <Typography>
          Coming Soon
        </Typography>
      </Box>
      {/* hide for race-ecosystem */}

    </>
  );
};
export default Projects;